module.exports = __webpack_public_path__ + "img/picto-change-avatar.2f6fb753.svg";